module.exports = __webpack_public_path__ + "static/media/pksuccess.13bf7d97.svg";